module.exports = __webpack_public_path__ + "img/teamBild.cd202e29.jpg";